module.exports = "/_next/static/images/largeBackground-46115c8370c07be8e68b7b95e386244c.png";